
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class ToggleTableCell extends Vue {
  @Prop({ type: Boolean, required: true }) public value: boolean;
  @Prop({ type: Number, required: true }) public idx: number;
  @Prop({ type: Boolean, required: false }) public readonly disabled: boolean;

  public toggleClicked(value: boolean) {
    if (!this.disabled) {
      this.$emit('changed', value, this.idx);
    }
  }
}
